<template>
	<el-container style="height:100%;">
		<el-aside :width="asideWidth" style="background-color: rgb(238, 241, 246);position: fixed; left: 0; ">
			<Aside :isCollapse="isCollapse"></Aside>
		</el-aside>

		<el-container style="height: 100%;">
			<el-header style="text-align: right; font-size: 12px; background-color: #2F8BEFFF;
				border-bottom: #2F8BEFFF 1px solid;position: fixed; top: 0; z-index: 1000;"
				:style="'margin-left:'+asideWidth +';width:'+screenWidth+'px;'">
				<Header @doCollapse="doCollapse" :icon="icon"></Header>
			</el-header>

			<el-main style="height: 100%;padding-left: 50px;padding-top: 100px;" :style="'margin-left:'+asideWidth">
				<!--        <Main></Main>-->
				<router-view />
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	import Aside from "./Aside";
	import Header from "./Header";
	// import Main from "./Main";

	export default {
		name: "Index",
		components: {
			Aside,
			Header
		},
		data() {
			return {
				isCollapse: false,
				asideWidth: '200px',
				icon: "el-icon-s-fold",
				screenWidth:window.screenWidth,
			}
		},
		mounted() {
			this.screenWidth = window.innerWidth - 200;
		},
		methods: {
			doCollapse() {
				this.isCollapse = !this.isCollapse;
				if (!this.isCollapse) { //展开
					this.asideWidth = '200px';
					this.icon = "el-icon-s-fold";
					this.screenWidth = window.innerWidth - 200;
				} else //关闭
				{
					this.asideWidth = '64px';
					this.icon = "el-icon-s-unfold";
					this.screenWidth = window.innerWidth - 64;
				}
			}
		}
	}
</script>

<style scoped>
	.el-header {
		background-color: #B3C0D1;
		color: #333;
		line-height: 60px;
	}

	.el-main {
		padding-top: 0;
	}

	.el-aside {
		color: #333;
	}
</style>
